export function checkNumber(val) {
  if (val.substring(0, 2) === "60") {
    return val;
  } else {
    return "60" + val;
  }
}
export function mapMobilenumb(val) {
  if (val.substring(0, 2) === "60") {
    return val.slice(2);
  } else {
    return val;
  }
}
export function getmobilecodes(data) {
  const phone = {
    dailcode: data.number.international.replace(/-/g, "").split(" "),
    number: data.number.significant,
  };
  return phone;
}

export function filterNumberInput(event) {
  // List of keys to prevent
  const keysToPrevent = ["e", "-", "+"];
  // Check if the pressed key is in the list
  if (keysToPrevent.includes(event.key)) {
    event.preventDefault(); // Prevent the key from being entered
  }
}
